module.exports = __webpack_public_path__ + "img/newsImg14.ad1a9ad0.png";